import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatDuration, formatPlays } from "@/utils/video";

export default function RelatedList({ videos }: { videos: Video[] }) {
  return (
    <ul className="flex flex-col gap-4">
      {videos.map((video) => (
        <li key={video.id}>
          <Link to={`/detail/${video.id}`} className="group flex gap-3">
            <div className="relative w-32 md:w-36 aspect-video shrink-0 rounded-md overflow-hidden bg-secondary-100">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} 糖豆视频`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute bottom-1 right-1 px-1 py-0.5 text-[10px] font-label text-background-50 bg-foreground-950/70 rounded">
                {formatDuration(video.duration)}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                {video.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500">{video.author}</p>
              <p className="mt-0.5 text-xs text-foreground-400">{formatPlays(video.plays)} 次播放</p>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}